import { get18YearsAgo } from '@helper/utils';
import { BasicDetails } from '@services/hooks/enduser-details';
import {
	NumberNullUndefinedUnionType,
	NumberNullUnionType,
	StringNullUndefinedUnionType,
} from '@helper/commonTypesAlias';
import { FormikValues } from 'formik';
import { Value } from '@components/common/date-picker';

export interface IStaticDetailsInitialValueProps {
	primary_number: StringNullUndefinedUnionType;
	birth_date: Date;
	wedding_anniversary: Date | string | null;
	samaj: StringNullUndefinedUnionType;
	permanent_address: StringNullUndefinedUnionType;
	permanent_town: StringNullUndefinedUnionType;
	permanent_state: StringNullUndefinedUnionType;
	permanent_zipcode: NumberNullUndefinedUnionType;
	permanent_street: StringNullUndefinedUnionType;
	permanent_city: StringNullUndefinedUnionType;
	website: StringNullUndefinedUnionType;
}

export const defaultStaticDetailFormInitialValues: IStaticDetailsInitialValueProps = {
	primary_number: '',
	birth_date: get18YearsAgo(),
	wedding_anniversary: new Date(),
	samaj: '',
	permanent_town: '',
	permanent_state: '',
	permanent_address: '',
	permanent_zipcode: null,
	permanent_city: '',
	permanent_street: '',
	website: '',
};

export type TFormik = {
	values: FormikValues;
	setFieldValue: (field: string, value: Value | string | string[] | boolean | number, shouldValidate?: boolean) => void;
	touched: FormikValues;
	errors: FormikValues;
	handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	setFieldError?: (field: string, value: string | undefined) => void;
	setFieldTouched?: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
};

export interface StaticDetailsCommonFormSectionProps {
	formik: TFormik;
	isEditing: boolean;
	getBasicFormData?: BasicDetails;
	formId: NumberNullUnionType;
}
